<template>
	<div>
		<custom-header></custom-header>
		<section class="content">
			<div class="columns">
				<div class="column">
					<h1>Status Page</h1>
				</div>
			</div>
      <div class="columns">
        <div class="column">
          <status-table :url="url"></status-table>
        </div>
      </div>
		</section>
	</div>
</template>

<script>
const url = "https://api.business.biya.com.ng/api/v1";
import CustomHeader from '@/components/CustomHeader';
import StatusTable from '../components/StatusTable';

export default {
  name: 'hello',
  components: {
    CustomHeader,
    StatusTable
  },
  data() {
    return {
      url: url + '/admin/status'
    };
  },
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?7f495cd3